module.exports = __webpack_public_path__ + "static/media/mapicc_medium.cdf17ab3.jpg";